import { render, staticRenderFns } from "./Other.html?vue&type=template&id=bdb7b1ce&scoped=true&"
import script from "./Other.vue?vue&type=script&lang=js&"
export * from "./Other.vue?vue&type=script&lang=js&"
import style0 from "./Other.scss?vue&type=style&index=0&id=bdb7b1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb7b1ce",
  null
  
)

export default component.exports